import './recoilDevConfig';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import * as Sentry from '@sentry/react';
import { Replay } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { environment } from './environments/environment';
import { shouldEnableSentry as computeShouldEnableSentry } from '../../../libs/merchant-cabinet/ui/src/lib/utils/sentry';

const shouldEnableSentry = computeShouldEnableSentry(environment.environment);
const isDevEnvironment = environment.environment === 'dev';

if (isDevEnvironment) {
  window.addEventListener('error', (event) => {
    if (
      event.message === 'ResizeObserver loop limit exceeded' ||
      event.message === 'ResizeObserver loop completed with undelivered notifications.'
    ) {
      event.stopImmediatePropagation();
    }
  });
}

if (shouldEnableSentry) {
  Sentry.init({
  dsn: 'https://e47b36c8f40c4cec9c63f0be3c478498@o4504331747262464.ingest.sentry.io/4504820049248256',
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: ['https://my.payler.com/'],
    }),
    new Replay(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.5,

  ignoreErrors: [
    'top.GLOBALS',
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'atomicFindClose',

    'NetworkError',
    'Network request failed',
    'Failed to fetch',
    'Load failed',

    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',

    'Timeout',
    'Request aborted',

    /^Script error\.?$/,
    /chrome-extension/,
    /moz-extension/,
  ],

  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^moz-extension:\/\//i,
  ],

  beforeSend(event, hint) {
    if (
      event.exception?.values?.[0]?.stacktrace?.frames?.some((frame) =>
        frame.filename?.includes('extension')
      )
    ) {
      return null;
    }

    const error = hint.originalException as any;
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
      if (![401, 403].includes(error.response.status)) {
        return null;
      }
    }

    if (event.request?.cookies) {
      delete event.request.cookies;
    }
    if (event.request?.headers?.Authorization) {
      event.request.headers.Authorization = '[Filtered]';
    }

    return event;
  },
  });
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
